/* Controls only. Never reconstruct, grade or recalculate the catalog report. */
(() => {
  'use strict';
  const STORAGE_KEY = 'mm_collector_collection_v2';
  function initialize(root) {
    if (root.dataset.controlsReady === 'true') return;
    root.dataset.controlsReady = 'true';
    const handle = root.dataset.reportHandle || '';
    if (!/^[a-zA-Z0-9-]+$/.test(handle)) return;
    const dialog = root.querySelector('[data-mmcr-dialog]');
    const form = root.querySelector('[data-mmcr-form]');
    const opener = root.querySelector('[data-mmcr-open]');
    const status = root.querySelector('[data-mmcr-status]');
    const formStatus = root.querySelector('[data-mmcr-form-status]');
    const fieldNames = ['status','quantity','purchase_price','purchase_date','condition','packaging','asking_price','acquisition_source','storage_location','notes'];
    const message = text => { if (status) status.textContent = text; };
    function read() {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      if (!value || typeof value !== 'object' || Array.isArray(value)) throw new Error('Unrecognized saved collection format');
      return value;
    }
    const moneyValue = value => {
      if (String(value ?? '').trim() === '') return null;
      const number = Number(value);
      if (!Number.isFinite(number) || number < 0) throw new Error('Enter a valid non-negative price.');
      return number;
    };
    const close = () => dialog?.close();
    if (dialog && form && opener && typeof dialog.showModal === 'function') {
      opener.hidden = false;
      opener.addEventListener('click', () => {
        try {
          const entry = read()[handle];
          form.reset();
          if (entry) {
            fieldNames.forEach(name => { if (form.elements.namedItem(name)) form.elements.namedItem(name).value = entry[name] ?? ''; });
            form.elements.namedItem('favorite').checked = Boolean(entry.favorite);
          }
          if (formStatus) formStatus.textContent = '';
          dialog.showModal();
        } catch (_) { message('Your saved collection could not be read. It has not been changed. Use your workspace backup before trying again.'); }
      });
      root.querySelector('[data-mmcr-close]')?.addEventListener('click', close);
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        try {
          const saved = read();
          const data = new FormData(form);
          const quantity = Number(data.get('quantity'));
          if (!Number.isInteger(quantity) || quantity < 1 || quantity > 9999) throw new Error('Enter a whole quantity between 1 and 9999.');
          const entry = { ...(saved[handle] || {}), handle, title:root.dataset.reportTitle || document.title, url:root.dataset.reportUrl || location.href,
            status:String(data.get('status')), quantity, purchase_price:moneyValue(data.get('purchase_price')), purchase_date:String(data.get('purchase_date') || ''),
            condition:String(data.get('condition') || 'not_graded'), packaging:String(data.get('packaging') || 'unknown'), asking_price:moneyValue(data.get('asking_price')),
            acquisition_source:String(data.get('acquisition_source') || '').trim().slice(0,160), storage_location:String(data.get('storage_location') || '').trim().slice(0,160),
            favorite:data.get('favorite') === 'on', notes:String(data.get('notes') || '').trim().slice(0,1000), updated_at:new Date().toISOString() };
          saved[handle] = entry;
          localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
          try { localStorage.setItem('mm-collector-backup-dirty-v1','1'); } catch (_) { /* Main entry is already saved. */ }
          window.dispatchEvent(new CustomEvent('mm:collection-record-saved',{detail:entry}));
          opener.textContent = 'Update Collection Entry';
          close();
          message('Saved in this browser. Export a backup from your workspace.');
        } catch (error) { if (formStatus) formStatus.textContent = error?.message || 'This browser could not save your collection entry.'; }
      });
    }
    const print = root.querySelector('[data-mmcr-print]');
    if (print) { print.hidden = false; print.addEventListener('click', () => window.print()); }
    const share = root.querySelector('[data-mmcr-share]');
    if (share && (navigator.share || navigator.clipboard?.writeText)) {
      share.hidden = false;
      share.addEventListener('click', async () => {
        try {
          const url = root.dataset.reportUrl || location.href.split('?')[0];
          if (navigator.share) await navigator.share({title:root.dataset.reportTitle || document.title,url});
          else await navigator.clipboard.writeText(url);
          message(navigator.share ? 'Report shared.' : 'Report link copied.');
        } catch (error) { if (error?.name !== 'AbortError') message('Sharing is unavailable. Copy the page address from your browser.'); }
      });
    }
  }
  const boot = scope => scope.querySelectorAll('[data-mmcr-readable]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), {once:true});
  else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
